import { render, staticRenderFns } from "./CategoryTreeNavNode.vue?vue&type=template&id=5b368108&scoped=true&"
import script from "./CategoryTreeNavNode.vue?vue&type=script&lang=js&"
export * from "./CategoryTreeNavNode.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTreeNavNode.vue?vue&type=style&index=0&id=5b368108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b368108",
  null
  
)

export default component.exports